export const notifyCardStyles = {
  optionCard: {
    borderRadius: '10px',
    padding: '10px 10px 0 10px',
  },
  cardHeader: {
    paddingBottom: '0',
  },
  cardAction: {
    margin: '0 5px',
  },
  contactBox: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '5px',
    marginBottom: '5px',
  },
  contactValueSection: {
    marginTop: '15px',
    marginBottom: '10px',
  },
  contactValue: {
    marginLeft: '10px',
    whiteSpace: 'pre-line',
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '20px',
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  },
};
